// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Make place for the overview map button */\n#BottomBar span.bottomlinks {\n    margin-right: 3em!important;\n}\n", ""]);
// Exports
module.exports = exports;
